import React, { useState } from 'react'
import cn from 'classnames'
import { ActionButton, ActionGroup, Icon, Overlay, Popover } from 'ui'
import styles from '@styles/components/TwoDFilterMenu.module.scss'
import ChevronIcon from '/public/s2_icon_chevron.svg'
import {
  useMediumMinimumSizePreference,
  useProjectState
} from '@hooks/useProject'
import { useTranslations } from 'use-intl'
import { useSceneActions } from '@hooks/useScene'

export type TwoDFilter = {
  description: string
  value: number
}

type Props = {
  filters: TwoDFilter[]
}

export function TwoDFilterMenu({ filters }: Props) {
  const t = useTranslations()
  const triggerBtnSize = useMediumMinimumSizePreference()
  const menuSize = useProjectState('sizePreference')
  const [selectedFilter, setSelectedFilter] = useState<TwoDFilter>(filters[0])
  const { apply2DFilter } = useSceneActions()

  const handleFilterButtonClick = (filter: TwoDFilter) => {
    setSelectedFilter(filter)
    apply2DFilter(filter.value)
  }

  return (
    <>
      <div className={styles['two-trigger-container']}>
        <ActionButton
          size={triggerBtnSize}
          id="two-d-filter-popover-trigger"
          quiet
          className={styles['trigger']}
        >
          {t('studio:2dFilterMenu:header')}
          <Icon className={styles['trigger-chevron-icon']}>
            <ChevronIcon />
          </Icon>
        </ActionButton>
      </div>

      <Overlay
        placement="bottom-start"
        offset={0}
        trigger="two-d-filter-popover-trigger@click"
      >
        <Popover
          className={cn(styles['popover'], styles[`popover-size-${menuSize}`])}
        >
          <ActionGroup
            className={styles['filter-group']}
            selects="single"
            selected={[selectedFilter.description]}
          >
            {filters.map(filter => {
              return (
                <ActionButton
                  key={filter.description}
                  value={filter.description}
                  onClick={() => handleFilterButtonClick(filter)}
                >
                  {t(filter.description)}
                </ActionButton>
              )
            })}
          </ActionGroup>
        </Popover>
      </Overlay>
    </>
  )
}
